import { Controller } from "stimulus";
import FormSimulate from "../entrypoints/src/admin/components/form_simulate";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
	static targets = [
		'modal',
		'form',
		'commentTextarea',
		'creditReplacementCheckbox'
	];

  connect() {
    !this.hasModalTarget && this.element.insertAdjacentHTML('beforeEnd', this.modalTemplate());

		$(document).on('click', '[data-action^="attendance-cancel"]', (ev) => {
			ev.preventDefault();
			this[ev.currentTarget.dataset.action.replace('attendance-cancel#', '')](ev);
		});
	}

	disconnect() {
		this.hasModalTarget && this.modalTarget.remove();
	}

	callToCancel(ev) {
		let dataset = ev.currentTarget.dataset;
		this.urlPathValue = dataset.urlPath;
		this.redirectTo = dataset.redirectTo;
		this.openModal();
	}

	async cancelAttendance() {
		AjaxLoader.show();
		FormSimulate.submit({
			method: 'post',
			action: this.urlPathValue,
			inputs: this.paramsForm
		});
	}

	openModal() {
		this.hasModalTarget && $(this.modalTarget).modal('show');
	}

	modalTemplate() {
		return `
			<div class="modal fade" tabindex="-1" role="dialog" data-attendance-cancel-target="modal">
				<div class="modal-dialog modal-md" role="document">
					<div class="modal-content">
						<div class="modal-header justify-content-start align-items-start">
							<h5 class="modal-title">Cancelar aula</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<form action="#" role="form" class="tr-form" data-attendance-cancel-target="form">
								<p>É importante que o aluno seja informado sobre o cancelamento da aula. <br> Utilize essa opção para comunicá-lo.</p>
								<p><strong>Nota:</strong> Essa ação poderá ser desfeita, caso necessário.</p>
								<div class="my-4">
									<label class="kt-checkbox kt-checkbox--light kt-checkbox--dark" for="credit-student-modal-replacement">
										<input type="checkbox" id="credit-student-modal-replacement" checked="checked" name="credit-replacement" data-attendance-cancel-target="creditReplacementCheckbox">
										<span></span>
										Atribuir crédito para que o aluno reponha a aula através do portal.
									</label>
								</div>

								<div class="form-group mb-0">
									<label>Mensagem para notificação (sms e whatsapp)</label>
									<textarea name="comment" cols="30" rows="5" class="form-control" data-attendance-cancel-target="commentTextarea"></textarea>
								</div>
							</form>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-gray-primary" data-dismiss="modal">Fechar</button>
							<button type="button" class="btn btn-purple" data-action="attendance-cancel#cancelAttendance">Cancelar Aula</button>
						</div>
					</div>
				</div>
			</div>
		`;
	}

	get paramsForm() {
		return `
			<input type="hidden" value="${this.commentTextareaTarget.value}" name="message" />
			<input type="hidden" value="${this.redirectTo}" name="redirect_to" />
			<input type="hidden" value="${this.creditReplacementCheckboxTarget.checked ? '1' : '0'}" name="credit_replacement" />
		`;
	}
}